<!-- 顾问微信二维码管理 -->
<template>
  <el-main>
    <div class="tableList">
      <div class="tableContent">
        <el-form :model="formValidate" :rules="ruleValidate" ref="formValidate" class="demo-ruleForm">
          <el-form-item prop="mainImage">
            <div class="list-img-box" :style="{display:'flex',flexDirection:'row'}">
              <img v-if="formValidate.mainImage" :src="formValidate.mainImage" :style="{width:'220px',height:'220px'}" alt="自定义图片">
              <div :style="{width:'220px',height:'220px',marginLeft:'10px'}" class="upload-btn" @click="uploadPicture('flagImg')">
                <i class="el-icon-plus" style="font-size: 30px;"></i><span>{{formValidate.mainImage == '' ? '添加图片':'编辑图片'}}</span>
              </div>
            </div>
            <input type="hidden" v-model="formValidate.mainImage" placeholder="请添加图片">
          </el-form-item>
        </el-form>
        <!-- 剪裁组件弹窗 -->
        <el-dialog title="裁切图片" :visible.sync="cropperModel" width="950px" center :close-on-click-modal="false" :before-close="handleClose">
          <cropper-image :Name="cropperName" :cropperType="3" @uploadImgSuccess="handleUploadSuccess" ref="child"></cropper-image>
        </el-dialog>
        <!--查看大封面-->
        <el-dialog title="查看大图片" :visible.sync="imgVisible" center>
          <img :src="imgName" v-if="imgVisible" style="width: 100%" alt="查看">
        </el-dialog>
      </div>
    </div>
  </el-main>
</template>

<script>
  import CropperImage from "../Dialog/CropperImage";
  import { quillEditor } from "vue-quill-editor"; //调用编辑器
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  export default {
    name: 'WeChatManagement',
    components: {
      CropperImage,
      quillEditor
    },
    data () {
      return {
        formValidate: {
          mainImage: '',//添加图片
          mainImageSrc: '',//回显图片
          imageId:"",// 图片id
        },
        ruleValidate: { //图片非空验证
          mainImage: [
            { required: true, message: '请上传图片', trigger: 'blur'}
          ],
        },
        cropperModel:false,//裁切图片参数弹出框
        cropperName:"",//裁切图片参数图片名称
        imgName: "",//裁切图片参数查看大图src
        imgVisible: false,//裁切图片参数是否查看大图
      }
    },
    computed: {
      editor() {
        return this.$refs.myQuillEditor.quill;
      },
    },
    methods: {
      // 获取表格数据
      getList(){
        let parameter = [{
          "field":"status",
          "fun":"ne",
          "value": "0"
        }];
        this.$api.findAdviserQr({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(res => {
          if (res.data.status == 200) {
            if (res.data.data.records != ""){
              this.formValidate.imageId = res.data.data.records[0].id;
              this.formValidate.mainImage = this.bindSrc(res.data.data.records[0].url);
            }
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 拼接页面图片地址
      bindSrc(url){
        return api_url+"/"+url;
      },
      //图片设置
      uploadPicture(name){
        this.cropperName = name;
        this.cropperModel = true;
      },
      //图片上传成功后
      handleUploadSuccess (data){
        this.formValidate.mainImageSrc = data[0].path;
        this.formValidate.mainImage = api_url+"/"+data[0].path;
        this.handleClose();
        this.onConfirm();
      },
      // 关闭上传弹出框
      handleClose() {
        this.cropperModel = false;
        this.$refs.child.beClose();
      },
      // 转码
      escapeStringHTML(str) {
        str = str.replace(/&lt;/g,'<');
        str = str.replace(/&gt;/g,'>');
        return str;
      },
      // 提交上传
      onConfirm() {
        let params = {},title="新增";
        if (this.formValidate.imageId == ""){
          params = {
            url:this.formValidate.mainImageSrc,
            status:1
          }
        } else {
          params = {
            id:this.formValidate.imageId,
            url:this.formValidate.mainImageSrc == ''?this.$route.query.data.url:this.formValidate.mainImageSrc,
            status:1
          }
          title = "编辑";
        }
        this.$api.saveOrUpdateAdviserQr({parameter: JSON.stringify(params)}).then(res => {
          if (res.data.status == 200) {
            this.$message({
              type: 'success',
              message: title+'成功！'
            });
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      }
    },
    mounted() {
      // 获取列表
      this.getList();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */
</style>





// WEBPACK FOOTER //
// src/components/Menu/WeChatManagement.vue